module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter",
      "id": "pg2sec1",
      "title": "Tools"
    }
  }, [_c('p', {
    staticClass: "h2aa"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_2",
      "title": "2"
    }
  }, [_vm._v("tools")])]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_c('i', [_vm._v("these are all my personal faves, but you should definitely try all kinds of tools to find what works for you")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "h2aa"
  }, [_vm._v("paper")]), _vm._v(" "), _c('p', {
    staticClass: "noindentbullet"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/bull.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "11",
      "src": "images/bull.jpg",
      "width": "8"
    }
  })]), _c('span', {
    staticClass: "spaceh"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('i', [_vm._v("TRACING PAPER")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentbullet"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/bull.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "11",
      "src": "images/bull.jpg",
      "width": "8"
    }
  })]), _c('span', {
    staticClass: "spaceh"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('i', [_vm._v("GRAPH PAPER")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentbullet"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/bull.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "11",
      "src": "images/bull.jpg",
      "width": "8"
    }
  })]), _c('span', {
    staticClass: "spaceh"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('i', [_vm._v("PLAIN WHITE PAPER")])])]), _vm._v(" "), _c('p', {
    staticClass: "h2aa"
  }, [_vm._v("pens")]), _vm._v(" "), _c('p', {
    staticClass: "noindentbullet"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/bull.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "11",
      "src": "images/bull.jpg",
      "width": "8"
    }
  })]), _c('span', {
    staticClass: "spaceh"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('i', [_vm._v("PIGMA MICRON by sakura of america")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentbullet"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/bull.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "11",
      "src": "images/bull.jpg",
      "width": "8"
    }
  })]), _c('span', {
    staticClass: "spaceh"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('i', [_vm._v("COPIC MARKERS")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentbullet"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/bull.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "11",
      "src": "images/bull.jpg",
      "width": "8"
    }
  })]), _c('span', {
    staticClass: "spaceh"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('i', [_vm._v("GELLY ROLL in white for dark paper")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentbullet"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/bull.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "11",
      "src": "images/bull.jpg",
      "width": "8"
    }
  })]), _c('span', {
    staticClass: "spaceh"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('i', [_vm._v("PILOT PRECISE V5 extra fine tip")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentbullet"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/bull.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "11",
      "src": "images/bull.jpg",
      "width": "8"
    }
  })]), _c('span', {
    staticClass: "spaceh"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('i', [_vm._v("PENTEL WATER BRUSH for brush lettering")])])]), _vm._v(" "), _c('p', {
    staticClass: "h2aa"
  }, [_vm._v("other stuff")]), _vm._v(" "), _c('p', {
    staticClass: "noindentbullet"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/bull.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "11",
      "src": "images/bull.jpg",
      "width": "8"
    }
  })]), _c('span', {
    staticClass: "spaceh"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('i', [_vm._v("PENCIL")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentbullet"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/bull.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "11",
      "src": "images/bull.jpg",
      "width": "8"
    }
  })]), _c('span', {
    staticClass: "spaceh"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('i', [_vm._v("ERASER")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentbullet"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/bull.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "11",
      "src": "images/bull.jpg",
      "width": "8"
    }
  })]), _c('span', {
    staticClass: "spaceh"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('i', [_vm._v("PENCIL SHARPENER")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentbullet"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/bull.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "11",
      "src": "images/bull.jpg",
      "width": "8"
    }
  })]), _c('span', {
    staticClass: "spaceh"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('i', [_vm._v("RULER or STRAIGHT EDGE")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dcd0f07c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Intsec1.vue
// module id = 84
// module chunks = 0